// Somehow this is not exported from lexical - https://github.com/facebook/lexical/blob/cde863d444adf9c189626c789b53657c3352dbb1/packages/lexical/src/LexicalUpdateTags.ts#L53
export const SKIP_DOM_SELECTION_TAG = 'skip-dom-selection';
